module.exports = __webpack_public_path__ + "img/DiNapoli-6.7910be0e.jpg";